import React from "react";
import { AdminSettingsProvider } from "./AdminSettingsContext";
import AdminSettingsShell from "./AdminSettingsShell";

export default function AdminSettingsLayout() {
  return (
    <AdminSettingsProvider>
      <AdminSettingsShell />
    </AdminSettingsProvider>
  );
}
